import gql from "graphql-tag";

export const dealerIncentiveBannerQuery = gql`
  query dealerIncentiveBanner($id: ID!) {
    dealerIncentive(id: $id) {
      id
      name
      description
      startsAt
      endsAt
      status
      reward
      color
      targetValue
      measurementUnit
      type {
        id
        name
      }
      banner {
        id
        name
        link
      }
      icon {
        id
        name
        link
      }
    }
  }
`;

export const dealerIncentiveRankingQuery = gql`
  query dealerIncentiveRanking(
    $dealerIncentiveId: ID!
    $page: Int
    $first: Int
    $orderBy: DealerIncentiveRankingOrderBy
  ) {
    dealerIncentiveRanking(
      dealerIncentiveId: $dealerIncentiveId
      page: $page
      first: $first
      orderBy: $orderBy
    ) {
      data {
        place
        customer {
          id
          name
          bonusProgramLevel {
            name
          }
        }
        progress {
          level
          shipmentsSum
          progressPercent
          levelTargetValue
          rewardMultiplier
        }
      }
      paginatorInfo {
        perPage
        currentPage
        lastPage
        total
        hasMorePages
      }
    }
  }
`;
